import { makeStyles, lighten, darken } from '@material-ui/core/styles';

const styles = makeStyles(theme => {
  const getColors = () => {
    const colors = {
      background: lighten(theme.palette.custom.background.app, 0.3),
      backgroundHover: darken(theme.palette.custom.background.app, 0.03),
      border: darken(theme.palette.custom.background.app, 0.1),
    };

    if (theme.palette.type === 'dark') {
      colors.background = theme.palette.custom.background.app;
      colors.backgroundHover = darken(theme.palette.custom.background.app, 0.1);
      colors.border = lighten(theme.palette.custom.background.app, 0.1);
    }
    return colors;
  };

  return {
    container: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius,
      border: `dashed 1px ${getColors().border}`,
      backgroundColor: getColors().background,
      transition: 'all .3s ease',

      '&:hover': {
        backgroundColor: getColors().backgroundHover,

        '& .cropOverlay': {
          color: getColors().backgroundHover,
        },
      },

      '& .avatar-wrapper': {
        width: '100%',
        height: 96,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        margin: 'auto',
        position: 'relative',
      },

      '& .avatar-loading': {
        position: 'absolute',
        zIndex: 1,
        color: theme.palette.text.primary,
      },

      '& .cropContainer': {
        minHeight: 96,
        width: '100%',
        position: 'relative',
        pointerEvents: 'none',
      },

      '& .cropOverlay': {
        color: getColors().background,
        backgroundColor: theme.palette.custom.surface[3],
        pointerEvents: 'all',
        transition: 'all .3s ease',
      },

      '& .avatar-button': {
        position: 'relative',
        borderRadius: '50%',
      },

      '& .remove-button': {
        position: 'absolute',
        left: '100%',
        marginLeft: theme.spacing(1),
        transition: 'all .3s ease',

        [theme.breakpoints.up('sm')]: {
          transform: 'translateX(-100%)',
          opacity: 0,
        },
      },

      '&:hover .remove-button': {
        transform: 'translateX(0%)',
        opacity: 1,
      },

      '& .link-button': {
        padding: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px`,
        cursor: 'pointer',

        '&:hover': {
          color: theme.palette.primary.main,
        },
      },

      '& input': {
        display: 'none',
      },
    },
  };
});

export default styles;
